export const Configurl = {
  DefaultOrganizationLogo: 'https://www.flame.edu.in/images/FLAME-menu-banner.svg',
  OrganizationName: 'FLAME',  
  apiBaseUrl: `${process.env.REACT_APP_BASE_URL}`,
};

export default Configurl;
